const WALLET_TYPE = {
    apple: 'apple',
    google: 'google'
};

export { WALLET_TYPE };
